<div class="header">
  <div class="role-control">
    <mat-form-field appearance="outline">
      <mat-label>{{ 'Rola' }}</mat-label>
      <mat-select [formControl]="select">
        <mat-option #matOption [value]="1">{{ 'Księgowość' | translate }}</mat-option>
        <mat-option #matOption [value]="2">{{ 'Kierownik HR' | translate }}</mat-option>
        <mat-option #matOption [value]="3">{{ 'Pracownik HR' | translate }}</mat-option>
        <mat-option #matOption [value]="4">{{ 'Przełożony' | translate }}</mat-option>
        <mat-option #matOption [value]="5">{{ 'Pracownik' | translate }}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <button mat-raised-button color="primary" class="add-document" (click)="save()">
    <span>{{ 'Zapisz' }}</span>
  </button>
</div>

<div class="list-container">
  <div class="example-container">
    <h2>Brak dostępu</h2>

    <div
      cdkDropList
      #todoList="cdkDropList"
      [cdkDropListData]="deny"
      [cdkDropListConnectedTo]="[doneList]"
      class="example-list"
      (cdkDropListDropped)="drop($event)"
    >
      @for (item of deny; track item) {
      <div class="example-box" cdkDrag>{{ item.Name }}</div>
      }
    </div>
  </div>

  <div class="example-container">
    <h2>Udostępniony</h2>

    <div
      cdkDropList
      #doneList="cdkDropList"
      [cdkDropListData]="allow"
      [cdkDropListConnectedTo]="[todoList]"
      class="example-list"
      (cdkDropListDropped)="drop($event)"
    >
      @for (item of allow; track item) {
      <div class="example-box" cdkDrag>{{ item.Name }}</div>
      }
    </div>
  </div>
</div>
